"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;
exports.default = getTimeZone;
